import '@carbon/charts/style.css';
import { BarChart, PieChart, DonutChart, LineChart, ScatterChart } from '@carbon/charts-react';
import { groupedBarData, groupedBarOptions, simpleBarData, simpleBarOptions, stackedBarData, stackedBarOptions, curvedLineData, curvedLineOptions, lineData, lineOptions, demoPieData, demoPieOptions, demoDonutOptions, scatterData, scatterOptions } from "../../../../src/data/charts/demo-chart-data";
import React from 'react';
export default {
  BarChart,
  PieChart,
  DonutChart,
  LineChart,
  ScatterChart,
  groupedBarData,
  groupedBarOptions,
  simpleBarData,
  simpleBarOptions,
  stackedBarData,
  stackedBarOptions,
  curvedLineData,
  curvedLineOptions,
  lineData,
  lineOptions,
  demoPieData,
  demoPieOptions,
  demoDonutOptions,
  scatterData,
  scatterOptions,
  React
};